import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const AboutClg = () => {
  const [aboutCollege, setAboutCollege] = useState(null);
  const fallbackCollegeImage =
    "https://images.shiksha.com/mediadata/images/1524210414phpyIBNDw.png";

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("about_clg");
      setAboutCollege(response.results[0]?.data || null);
    };

    fetchData();
  }, []);

  if (!aboutCollege) {
    return (
      <section className="py-14 md:py-16 bg-[#f4f7ff]">
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-4xl rounded-3xl border border-slate-200 bg-white p-6 md:p-8">
            <div className="h-5 w-40 animate-pulse rounded bg-slate-200" />
            <div className="mt-3 h-9 w-72 animate-pulse rounded bg-slate-200" />
            <div className="mt-8 space-y-3">
              {[...Array(4)].map((_, idx) => (
                <div key={idx} className="h-4 animate-pulse rounded bg-slate-200" />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0;
    const elements = [];

    spans.forEach((span) => {
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>
            {text.slice(span.start, span.end)}
          </strong>
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-[#d90845] hover:text-[#b10639] underline underline-offset-2"
          >
            {text.slice(span.start, span.end)}
          </a>
        );
      }

      lastIndex = span.end;
    });

    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };

  const collegeImage =
    aboutCollege.image?.url ||
    aboutCollege.college_image?.url ||
    fallbackCollegeImage;

  return (
    <section className="relative overflow-hidden py-14 md:py-16">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${collegeImage})` }}
      />
      <div className="absolute inset-0 bg-white/90" />
      <div className="pointer-events-none absolute -top-28 left-0 h-72 w-72 rounded-full bg-[#d90845]/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 right-0 h-72 w-72 rounded-full bg-cyan-400/10 blur-3xl" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="mx-auto max-w-4xl rounded-[2.5rem] border border-white/40 bg-white/95 p-8 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.1)] backdrop-blur-sm md:p-12">
          <div className="text-center">
            <span className="inline-flex rounded-full border border-pink/20 bg-pink/5 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-pink">
              About The College
            </span>
            <h2 className="mt-6 text-2xl font-extrabold leading-tight text-slate-900 md:text-2xl tracking-tight">
              {aboutCollege.title?.[0]?.text || "About The College"}
            </h2>
          </div>

          <div className="mt-6 space-y-4 text-justify text-sm leading-7 text-slate-700 md:text-base">
            {(aboutCollege.description || []).map((para, index) => (
              <p
                key={index}
                className="m-0"
              >
                {renderTextWithSpans(para.text, para.spans)}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutClg;
